/*
 * roles Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { RESET_STATE } from '../auth/constants';

const initialState = {};

type State = {};

export default function (state: State = initialState, action?: any): State {
    if (!action) return state;
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED: {
            const roles = get(action, 'payload.entities.roles', {});
            return {
                ...roles
            };
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
